import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WebhookIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Webhook",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M25.143 16.983a6.9 6.9 0 0 0-2.39.431l-4.78-8.282A2.26 2.26 0 0 0 18.285 8c0-1.26-1.025-2.286-2.285-2.286S13.715 6.74 13.715 8 14.74 10.286 16 10.286l5.867 10.166.99-.57a4.6 4.6 0 0 1 2.286-.613 4.577 4.577 0 0 1 4.572 4.57 4.57 4.57 0 0 1-6.857 3.96l-1.145 1.98a6.857 6.857 0 1 0 3.43-12.796"
    }), /*#__PURE__*/_jsx("path", {
      d: "M25.143 26.125c1.26 0 2.286-1.025 2.286-2.285s-1.026-2.285-2.286-2.285c-.842 0-1.571.463-1.968 1.142H11.43v1.143a4.577 4.577 0 0 1-4.572 4.572 4.577 4.577 0 0 1-4.572-4.572 4.59 4.59 0 0 1 2.288-3.96L3.427 17.9A6.89 6.89 0 0 0 0 23.84a6.865 6.865 0 0 0 6.857 6.857c3.392 0 6.216-2.475 6.762-5.715h9.556a2.28 2.28 0 0 0 1.968 1.143"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.571 23.84a2.29 2.29 0 0 0 2.286 2.285 2.29 2.29 0 0 0 2.286-2.285c0-.414-.12-.797-.313-1.132l5.875-10.18-.994-.57A4.57 4.57 0 0 1 11.429 8c0-2.52 2.05-4.571 4.571-4.571S20.571 5.479 20.571 8h2.285c0-3.781-3.075-6.857-6.856-6.857S9.144 4.219 9.144 8c0 2.062.93 4 2.485 5.286l-4.772 8.269A2.29 2.29 0 0 0 4.57 23.84"
    })]
  }));
};
WebhookIcon.displayName = 'WebhookIcon';